import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { LoginComponent } from './features/auth/login/login.component';
import { CheckRedirectsComponent } from './features/check-redirects/check-redirects.component';
import { ConversationHistoryComponent } from './features/conversation-history/conversation-history.component';
import { FireSafetyInstancesWidgetComponent } from './features/dashboard/components/fire-safety-instances/fire-safety-instances-widget.component';
import { Voice2VoiceTranscriptsComponent } from './features/voice2voice-transcripts/voice2voice-transcripts.component';
import { ConversationQualityComponent } from './features/conversation-quality/conversation-quality.component';

export const routes: Routes = [
  { path: 'login', loadComponent: () => LoginComponent },
  {
    path: 'dashboard',
    loadComponent: () => DashboardComponent,
    canActivate: [authGuard],
  },
  { path: '', component: LoginComponent },
  {
    path: 'check-tmti-redirections',
    loadComponent: () => CheckRedirectsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'conversation-history',
    loadComponent: () => ConversationHistoryComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fire-safety-check',
    loadComponent: () => FireSafetyInstancesWidgetComponent,
    canActivate: [authGuard],
  },
  {
    path: 'voice2voice-transcripts',
    loadComponent: () => Voice2VoiceTranscriptsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'conversation-quality',
    loadComponent: () => ConversationQualityComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'evaluation-results',
        loadComponent: () => ConversationQualityComponent,
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];
